import React from 'react';
import LoginForm from '../components/Auth/LoginForm';

const LoginPage = () => <LoginForm />;

export default LoginPage;